const store = (key, values) => {
  key = `${pipelineConfig.pathPrefix}:${key}`

  window.localStorage.setItem(key, JSON.stringify(values))
}

const load = (key) => {
  key = `${pipelineConfig.pathPrefix}:${key}`

  const data = window.localStorage.getItem(key)

  if (data) {
    return JSON.parse(data)
  } else {
    return null
  }
}

export { store, load }
